var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1B75BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51769 4.83863L9 7.4295L11.4216 4.83863L12.9375 6.39L10.4648 9L12.9375 11.5892L11.4216 13.1602L9 10.5705L6.51769 13.1602L5.0625 11.6325L7.515 8.98537L5.0625 6.39L6.51769 4.83863ZM6.71738 4.62712L8.98988 2.25L11.2624 4.62712L10.0665 5.90119L8.98988 4.71206L7.91325 5.90119L6.71738 4.62712ZM6.71738 13.3729L7.91325 12.0988L8.98988 13.2879L10.0665 12.0988L11.2624 13.3729L8.98988 15.75L6.71738 13.3729Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdx);
export default __webpack_public_path__ + "static/media/adx.1f10ff0f5703385e7eb90e7dc95825b2.svg";
export { ForwardRef as ReactComponent };